import { ACTION_TYPES } from "../../../Constants";

export const setNewSiteLogo = (logo) => ({
  type: ACTION_TYPES.SITE_LOGO,
  payload: logo,
});
